import JDate from "jalali-date";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Container,
  Dropdown,
  ListGroup,
  Modal,
  Row,
} from "react-bootstrap";
import "react-confirm-alert/src/react-confirm-alert.css";
import Context from "../Context";
import { export_to_doc } from "../Drivers/MSWord";
import Description from "../Elements/allContent";
import axios from "axios";
import renderHTML from "react-render-html";
import htmlToText from "html-to-text";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ConfirmationModal from "../Elements/ConfirmationModal";
import CreateDocument from "../Elements/CreateDocument";
import DocumentItem from "../Elements/DocumentItem";
import EditDocument from "../Elements/EditDocument";
import InputCSL from "../Elements/InputCSL";
import { downloadBibtex } from "../Libs/Bibtex";
import { downloadRIS } from "../Libs/RIS";
import Document1 from "../Lottie/Document1";
import { topCsls } from "../constants/topCsls";

const jdate = new JDate();
export default () => {
  const context = useContext(Context);
  const [active_csl, set_active_csl] = useState(topCsls[0]);
  const [imported_csls, set_imported_csls] = useState([]);

  const addHeadingsToCombinedHtml = (html, isFarsi) => {
    if (!html || typeof html !== "string") return html;
    const inTextTitle = isFarsi ? "استناد درون متن" : "In-text citations";
    const bibTitle = isFarsi ? "استناد برون متن ( کتابنامه )" : "Bibliography";
    let updated = html;
    updated = updated.replace(
      /(<div[^>]*class=["'][^"']*\bcitations\b[^"']*["'][^>]*>)/i,
      `<h5 style="margin: 1em 0;">${inTextTitle}</h5>$1`,
    );
    updated = updated.replace(
      /(<div[^>]*class=["'][^"']*\bcsl-bib-body\b[^"']*["'][^>]*>)/i,
      `<h5 style="margin: 1em 0;">${bibTitle}</h5>$1`,
    );
    return updated;
  };

  const loadDefaultCsls = () => {
    const cachedMapped = sessionStorage.getItem("cite_allCsls");
    if (cachedMapped) {
      set_imported_csls(JSON.parse(cachedMapped));
      return;
    }

    const cachedRaw = sessionStorage.getItem("allCsls");
    const mapToOptions = csls =>
      csls.map(item => ({
        key: item.csl_file,
        value: item.title_fa,
        id: item.id,
      }));

    if (cachedRaw) {
      try {
        const parsed = JSON.parse(cachedRaw);
        if (Array.isArray(parsed)) {
          const mapped = mapToOptions(parsed);
          set_imported_csls(mapped);
          sessionStorage.setItem("cite_allCsls", JSON.stringify(mapped));
          return;
        }
      } catch (e) {}
    }

    try {
      const { ApiDriver } = context;
      if (ApiDriver && typeof ApiDriver.getCsls === "function") {
        ApiDriver.getCsls(
          { page_size: 1000 },
          data => {
            const csls = data.data;
            sessionStorage.setItem("allCsls", JSON.stringify(csls));
            const mapped = mapToOptions(csls);
            set_imported_csls(mapped);
            sessionStorage.setItem("cite_allCsls", JSON.stringify(mapped));
          },
          error => {
            console.log(error);
          },
        );
      }
    } catch (err) {
      console.error("خطا در دریافت لیست:", err);
    }
  };
  useEffect(loadDefaultCsls, []);

  const [history, set_history] = useState(
    JSON.parse(sessionStorage.getItem("history") || "[]"),
  );

  useEffect(() => {
    sessionStorage.setItem("history", JSON.stringify(history));
  }, [history]);

  const [citeproc_loading, set_citeproc_loading] = useState(false);
  const [citeproc_error, set_citeproc_error] = useState("");
  const [citeproc, set_citeproc] = useState([]);
  const [combinedHtml, set_combined_html] = useState("");
  const citeprocRequest = useRef(0);
  const [showEditPicker, set_show_edit_picker] = useState(false);
  const [editingIndex, set_editing_index] = useState(null);
  const [showEdit, set_show_edit] = useState(false);
  const fetchCiteProc = () => {
    const requestId = ++citeprocRequest.current;
    if (active_csl === null || history.length === 0) {
      set_citeproc_loading(false);
      set_citeproc_error("");
      set_combined_html("");
      set_citeproc([]);
      return;
    }
    const cslItems = history.map((item, index) => {
      const id = `ITEM-${index + 1}`;
      return { ...item, id };
    });

    const itemsPayload = cslItems.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});

    const citationClusters = cslItems.map(it => ({
      citationItems: [
        {
          id: it.id,
          ...(it.locator ? { locator: it.locator } : {}),
          ...(it.lable ? { lable: it.lable } : {}),
          ...(it.locator2 ? { locator2: it.locator2 } : {}),
          ...(it.lable2 ? { lable2: it.lable2 } : {}),
        },
      ],
      properties: { noteIndex: 0 },
    }));

    const payload = {
      items: itemsPayload,
      citationClusters,
    };
    set_combined_html("");
    set_citeproc([]);
    set_citeproc_error("");
    set_citeproc_loading(true);

    const locale =
      history[0] && history[0].language === "fa" ? "fa-IR" : "en-US";

    axios
      .post(
        `https://cite.pajoohyar.ir/?responseformat=html&style=${encodeURIComponent(
          active_csl.key,
        )}&locale=${encodeURIComponent(locale)}&citations=1&bibliography=1`,
        payload,
        {
          timeout: 15000,
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then(res => {
        if (requestId !== citeprocRequest.current) return;

        if (typeof res.data === "string" && res.data.trim()) {
          set_combined_html(res.data);
        } else if (
          res.data &&
          typeof res.data.html === "string" &&
          res.data.html.trim()
        ) {
          set_combined_html(res.data.html);
        } else if (res.data && Array.isArray(res.data.data)) {
          set_citeproc(res.data.data);
        } else {
          throw new Error("Citation service returned an empty response");
        }
      })
      .catch(err => {
        if (requestId !== citeprocRequest.current) return;
        console.error(err);
        set_citeproc_error(
          "در حال حاضر تولید استناد با مشکل مواجه شده است. لطفاً دوباره تلاش کنید.",
        );
      })
      .finally(() => {
        if (requestId === citeprocRequest.current) {
          set_citeproc_loading(false);
        }
      });
  };

  const removeAll = () => {
    context.showConfirmationModal(
      "حذف همه",
      "مطمئنید که می‌خواهید همه آیتم‌ها را حذف کنید؟",
      [
        {
          label: "بله",
          onClick: () => {
            set_history([]);
            set_citeproc([]);
          },
          variant: "danger",
        },
        {
          label: "خیر",
          onClick: () => {},
        },
      ],
    );
  };
  const createdItem = item => {
    set_history(history.concat([item]));
  };
  const go_to_download_pajoohyar = () => {
    window.location = "https://pajoohyar.ir/product";
  };
  useEffect(fetchCiteProc, [
    JSON.stringify(active_csl || {}),
    JSON.stringify(history),
  ]);
  return [
    <div>
      <div className="cite-Header">
        <div className="cite-Header-content-btn">
          <a href="#content" className="hero-sample-btn cite-Header-btn">
            شروع کنید
          </a>
        </div>
      </div>
      <div key="content" id="content">
        <Row
          style={{
            marginTop: 0,
            marginLeft: 0,
            marginRight: 0,
            backgroundColor: "rgb(238, 238, 238)",
          }}>
          <Col md={{ span: 12 }}>
            <Card
              style={{ backgroundColor: "rgb(238, 238, 238)", border: "none" }}
              className="cite__myCitation">
              <Container className="cite__myCitation">
                <Card.Body className="cite__myCitation">
                  {history.length > 0 ? (
                    <Row>
                      <Col
                        md={12}
                        style={{ minHeight: 200 }}
                        className="cite__myCitation">
                        {citeproc_loading ? (
                          <Document1 />
                        ) : (
                          <Row>
                            <Col md={12} className="cite__myCitation">
                              {citeproc_error ? (
                                <div className="alert alert-danger text-right">
                                  {citeproc_error}
                                  <Button
                                    variant="link"
                                    size="sm"
                                    onClick={fetchCiteProc}>
                                    تلاش دوباره
                                  </Button>
                                </div>
                              ) : combinedHtml ? (
                                (() => {
                                  const lang =
                                    (history[0] && history[0].language) || "fa";
                                  const isFarsi = lang === "fa";
                                  const direction = isFarsi ? "rtl" : "ltr";
                                  const textAlign = isFarsi ? "right" : "left";
                                  return (
                                    <ListGroup.Item
                                      style={{
                                        direction,
                                        textAlign,
                                        position: "relative",
                                        backgroundColor: "#fff",
                                        border: "1px solid rgba(0,0,0,.125)",
                                      }}>
                                      <div className="results">
                                        <div
                                          style={{
                                            direction,
                                            textAlign,
                                            marginLeft: isFarsi ? 30 : 0,
                                          }}
                                          id="results">
                                          {renderHTML(
                                            addHeadingsToCombinedHtml(
                                              combinedHtml,
                                              isFarsi,
                                            ),
                                          )}
                                        </div>
                                      </div>
                                      <Dropdown
                                        align="end"
                                        style={{
                                          position: "absolute",
                                          top: 4,
                                          left: 4,
                                        }}>
                                        <Dropdown.Toggle
                                          variant="light"
                                          size="sm">
                                          <i className="fa fa-bars" />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                          <Dropdown.Item
                                            onClick={() =>
                                              set_show_edit_picker(true)
                                            }>
                                            ویرایش
                                          </Dropdown.Item>
                                          <CopyToClipboard
                                            text={htmlToText.fromString(
                                              combinedHtml,
                                              { wordwrap: false },
                                            )}>
                                            <Dropdown.Item>کپی</Dropdown.Item>
                                          </CopyToClipboard>
                                          <Dropdown.Item onClick={removeAll}>
                                            حذف همه
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                      <Modal
                                        style={{ zIndex: 9999 }}
                                        className="csl-modal"
                                        show={showEditPicker}
                                        onHide={() =>
                                          set_show_edit_picker(false)
                                        }
                                        size="lg">
                                        <Modal.Header closeButton>
                                          <Modal.Title>
                                            انتخاب آیتم برای ویرایش
                                          </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                          <ListGroup>
                                            {history.map((doc, idx) => (
                                              <ListGroup.Item
                                                key={idx}
                                                style={{
                                                  display: "flex",
                                                  justifyContent:
                                                    "space-between",
                                                  alignItems: "center",
                                                }}>
                                                <span>
                                                  {doc.title ||
                                                    doc.id ||
                                                    `آیتم ${idx + 1}`}
                                                </span>
                                                <Button
                                                  variant="outline-primary"
                                                  size="sm"
                                                  onClick={() => {
                                                    set_editing_index(idx);
                                                    set_show_edit(true);
                                                    set_show_edit_picker(false);
                                                  }}>
                                                  ویرایش
                                                </Button>
                                              </ListGroup.Item>
                                            ))}
                                          </ListGroup>
                                        </Modal.Body>
                                      </Modal>
                                      {editingIndex !== null && (
                                        <EditDocument
                                          document={history[editingIndex]}
                                          updated={updatedDoc => {
                                            set_history(
                                              history.map((doc, i) =>
                                                i === editingIndex
                                                  ? updatedDoc
                                                  : doc,
                                              ),
                                            );
                                          }}
                                          show={showEdit}
                                          set_show={set_show_edit}
                                        />
                                      )}
                                    </ListGroup.Item>
                                  );
                                })()
                              ) : (
                                <ListGroup>
                                  {citeproc.map((item, index) => (
                                    <DocumentItem
                                      key={index}
                                      document={history[index]}
                                      citeproc={item}
                                      updated={document => {
                                        set_history(
                                          history.map((doc, i) =>
                                            i === index ? document : doc,
                                          ),
                                        );
                                      }}
                                      removed={document => {
                                        set_history(
                                          history.filter((doc, i) =>
                                            i === index ? null : doc,
                                          ),
                                        );
                                      }}
                                    />
                                  ))}
                                </ListGroup>
                              )}
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  ) : (
                    <Row style={{ display: "none" }}></Row>
                  )}
                  {history.length > 0 ? (
                    <Row>
                      <Col md={12}>
                        <CreateDocument created={createdItem} />
                      </Col>
                      <Col md={12}>
                        <Row>
                          <Col md={7}>
                            <InputCSL
                              changedCsl={csl => {
                                set_active_csl(csl);
                              }}
                              active_csl={active_csl}
                              imported_csls={imported_csls}
                              set_imported_csls={set_imported_csls}
                            />
                          </Col>
                          <Col md={5} style={{ paddingTop: 10 }}>
                            <ButtonGroup style={{ direction: "ltr" }} size="sm">
                              <Button
                                className="cite__myButtonGroup"
                                style={{ color: "red" }}
                                onClick={removeAll}>
                                حذف همه
                              </Button>
                              <Button
                                className="cite__myButtonGroup"
                                style={{ color: "#ff790c" }}
                                onClick={go_to_download_pajoohyar}>
                                دانلود پژوهیار
                              </Button>
                              <Dropdown
                                className="hide-drop"
                                style={{
                                  display: "inline",
                                  marginLeft: 0,
                                  borderRadius: 0,
                                  backgroundColor: "#eee",
                                }}>
                                <Dropdown.Toggle
                                  variant="info"
                                  id="dropdown-basic"
                                  className="cite__dropDownButton"
                                  style={{
                                    borderRadius: 0,
                                    backgroundColor: "#eee",
                                    color: "#6da7b1",
                                  }}>
                                  <i
                                    className="fa fa-cloud-download"
                                    aria-hidden="true"></i>{" "}
                                  دریافت خروجی
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => {
                                      export_to_doc(
                                        "results",
                                        `pajoohyar_${jdate.format(
                                          "YYYY-MM-DD",
                                        )}_${new Date().getHours()}_${new Date().getMinutes()}`,
                                      );
                                    }}>
                                    <i
                                      className="fa fa-file-word-o"
                                      aria-hidden="true"></i>{" "}
                                    Word
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      downloadBibtex(
                                        history,
                                        `pajoohyar_${jdate.format(
                                          "YYYY-MM-DD",
                                        )}_${new Date().getHours()}_${new Date().getMinutes()}`,
                                      );
                                    }}>
                                    <i
                                      className="fa fa-file-excel-o"
                                      aria-hidden="true"></i>{" "}
                                    BibTeX{" "}
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      downloadRIS(
                                        history,
                                        `pajoohyar_${jdate.format(
                                          "YYYY-MM-DD",
                                        )}_${new Date().getHours()}_${new Date().getMinutes()}`,
                                      );
                                    }}>
                                    <i
                                      className="fa fa-file-image-o"
                                      aria-hidden="true"></i>{" "}
                                    RIS
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </ButtonGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col md={12}>
                        <CreateDocument created={createdItem} />
                      </Col>
                    </Row>
                  )}
                </Card.Body>
              </Container>
            </Card>
          </Col>
        </Row>
      </div>
      <Description key="mycontent" />
      <ConfirmationModal />
    </div>,
  ];
};
